import {disableScroll, enableScroll} from './utils';

const sortByCategoryFaq = () => {
    const overlay = $('.loading-overlay');

    $('.js-filter-btn').on('click', function () {
        $('.js-filter-btn').removeClass('active');
        $(this).addClass('active');
        let currentTerm = $(this).attr('data-term-id');
        $('.load-more-faq-btn').attr('data-cat-id', currentTerm);

        let data = {
            action: "tr_ajax_filter_by",
            category: $(this).data('term-id'),
            category_title: $(this).data('term-title'),
        };

        $.ajax({
            type: 'POST',
            url: themeVars.ajaxurl,
            data: data,

            beforeSend: function () {
                overlay.addClass('active');
                disableScroll();
            },

            success: function (res) {
                if (res.trim()==='') {
                    overlay.removeClass('active');
                    enableScroll();
                    $('.js-filter-result').html('<p class="nothing-found">Nothing Found</p>');
                    const scrollToElement = document.querySelector(".tr-faq-filters__faq");
                    scrollToElement.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
                } else {
                    overlay.removeClass('active');
                    enableScroll();
                    $('.js-filter-result').html(res);
                    const scrollToElement = document.querySelector(".tr-faq-filters__faq");
                    scrollToElement.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
                }
            },

            error: function () {
                overlay.removeClass('active');
            },
        })
    });
};
export default sortByCategoryFaq;
